import {
  Datagrid,
  DateField,
  List,

  TextField,
  TextInput,
  ReferenceInput,
  SelectInput,
  ReferenceField,
  SimpleForm,
  Edit,
  SingleFieldList,
  ChipField,

  BooleanInput,
  usePermissions,

  Show,


  ReferenceArrayInput,
  AutocompleteArrayInput,
  ReferenceArrayField,

  useRecordContext,
  Create,
  FormDataConsumer,

  AutocompleteInput,

  RadioButtonGroupInput,
  SelectField
} from "react-admin";

import {
  Button,
  Grid,
  Chip,

} from '@mui/material';

import { isMobile } from 'react-device-detect';

import { useState } from 'react';
import { ROLES, SERVER } from "../../../constants";
import { ColoredChipField } from "../../needs/Needs";
import { IdateTimeInput } from '../../../data/IdateTimeInput';
import ShowActionsPermission from "../../../components/ShowActionsWithPermission";
import { HttpClient } from "../../../utils/requests";
import { Aside } from "../CRMAside";
import { ReminderCreateCommentButton } from "./ReminderCreateButton";

export const choicesTime = [
  { id: 'NEVER', name: 'هرگز  ' },
  { id: 'EVERY_1_WEEK', name: 'هر هفته  ' },
  { id: 'EVERY_2_WEEK', name: 'هر ۲ هفته  ' },
  { id: 'EVERY_4_WEEK', name: 'هر ۴ هفته ' },
  { id: 'EVERY_6_WEEK', name: 'هر ۶ هفته ' },
  { id: 'EVERY_12_WEEK', name: 'هر ۱۲ هفته ' },

]
export const ReminderList = (props) => {
  return (
    //رتبه مخاطب
    <List {...props} perPage={40} sort={{ field: 'updatedAt', order: 'DESC' }}>
      {isMobile ? (
        <Datagrid rowClick="edit">
          <TextField source="title" label="عنوان " />
          <ReferenceField source="contact" label="مشتری من" variant="outlined" reference="contact">
            <ChipField source="name" />
          </ReferenceField>
          <DateField label="زمان پیگیری" source="reminderTime" options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />

        </Datagrid>
      ) : (

        <Datagrid rowClick="edit" >

          <ReferenceArrayField label="پیگیری کننده" source="users" reference="adminUsers">
            <SingleFieldList linkType={null} >
              <ChipField source="name" />
            </SingleFieldList>
          </ReferenceArrayField>


          <DateField label="زمان پیگیری" source="reminderTime" options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
          {/* <TextField source="description" label="یادداشت" /> */}

          <SelectField source="reminderPeriod" label="تکرار پیگیری" choices={choicesTime} />
          {/* source name ?*/}
          <ReferenceField link={null} source="contact" label="مشتری من" variant="outlined" reference="contact">
            <ChipField source="name" />
          </ReferenceField>

          <ReferenceField link={null} source="callType" label="نوع تماس" variant="outlined" reference="preferCall">
            <ColoredChipField source="title" />
          </ReferenceField>
          <TextField source="title" label="عنوان " />

        </Datagrid>
      )}

    </List >
  )
};

export const ReminderEdit = (props) => (
  <Edit {...props} actions={null} aside={<Aside sx={{ height: "40px" }} />}>
    <SimpleForm submitOnEnter={false} variant="outlined" redirect="list" >
      <div style={{
        margin: "16px 0px",
        position: "absolute",
        left: "10vh",
        top: "7vh",
        width: "auto"
      }}>
        <ReminderCreateCommentButton reminder={props}
        />
      </div>

      <Grid container spacing={3} style={{ marginRight: "16px", }}>

        <Grid item xs={4} style={{ display: 'inline-grid', gridTemplateRows: 'auto', gap: 1, }} >
          <BooleanInput source="active" label="فعال" variant="outlined" />
          <TextInput source="title" label="عنوان" variant="outlined" />

          <TextInput source="phoneNumber" variant="outlined" label="شماره تماس" />
          <TextInput type="text" variant="outlined" disabled={true} source="contactName" label="نام مخاطب" />


          <ReferenceInput variant="outlined" label="مشتری" source="company" reference="customer">
            <AutocompleteInput optionText="name" />
          </ReferenceInput>
          <TextInput source="companyName" label="نام مشتری" />

          <TextInput source="description" label="یادداشت" multiline variant="outlined" rows={5} width="60%" />

          <ReferenceInput source="callType" label="نوع تماس" variant="outlined" reference="preferCall">
            <SelectInput optionText="title" />
          </ReferenceInput>
          <ReferenceArrayInput variant="outlined" source="users" label="همکاران" reference="adminUsers">
            {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
            <AutocompleteArrayInput style={{ width: "70%" }} source="name" optionText="name" />
          </ReferenceArrayInput >
          {isMobile ? (
            <div>
              <IdateTimeInput fullWidth source='reminderTime' variant="outlined" label="زمان پیگیری" />
              <br />
              <Button fullWidth >تکرار پیگیری</Button>
              <RadioButtonGroupInput label="" row={false} defaultValue="NEVER" source="reminderPeriod" choices={choicesTime} />
            </div>

          ) : (
            <></>
          )}
        </Grid>

        {!isMobile ? (

          <Grid item xs={6}>
            <IdateTimeInput fullWidth source='reminderTime' variant="outlined" label="زمان پیگیری" />


            <br />
            <Button fullWidth >تکرار پیگیری</Button>
            <RadioButtonGroupInput label="" row={false} defaultValue="NEVER" source="reminderPeriod" choices={choicesTime} />

          </Grid>
        ) : (<></>)}

      </Grid>

    </SimpleForm>
  </Edit>
);
export const StarChipField = props => {
  const record = useRecordContext();
  let phone = record.phoneNumber

  phone = phone.substring(phone.length - (phone.length / 2), phone.length) + '*'.repeat(phone.length / 2);
  return (
    <Chip label={phone} />
  );
};

export const ReminderShow = (props) => {
  // const [page, setPage] = useState(1);
  const { permissions } = usePermissions();
  // const createProps = { record: { "reminderName": 'myValue' } }
  // const perPage = 1;
  return (

    <Show
      actions={<ShowActionsPermission />}
      style={{ marginRight: "8px" }}  {...props} variant="outlined" aside={<Aside sx={{ height: "40px" }} />} >
      <div>
        <div style={{
          margin: "16px 0px",
          position: "absolute",
          left: "10vh",
          top: "6vh"
        }}>
          <ReminderCreateCommentButton reminder={props}
          />
        </div>

        <Grid container spacing={2} style={{ marginRight: "16px" }}>
          <Grid item xs={6}>
            <br />
            تماس گیرنده
            <ReferenceField link={permissions?.includes(ROLES.SUPER_ADMIN) ? 'show' : null} label="تماس گیرنده" source="contact" reference="contact">
              <ChipField source="name" />
            </ReferenceField>
            <br />
            شماره تماس
            <StarChipField source="phoneNumber" />
            <br />

            عنوان <ChipField source="title" />
            <br />
            <ReferenceField link="show" source="ownerAdmin" reference="adminUsers" >
              <TextField source="name" />
            </ReferenceField>
            همکاران  <br /> <br /><ReferenceArrayField source="users" reference="adminUsers" >
              <SingleFieldList linkType="show">
                <ChipField source="name" />
              </SingleFieldList>
            </ReferenceArrayField>
          </Grid>
          <Grid item xs={6}>

            <br />
            ایجاد کننده
            <ChipField source="ownerAdmin.name" />

            <br />
            وضعیت تماس

            <ReferenceField link={null} source="callResult" reference="statusCall" >
              <ColoredChipField source="title" select="id" />
            </ReferenceField>

          </Grid>
          <Grid item xs={5}>
            نوع سفارش
            <br />
            <br />
            <br />
            <br />
            {permissions?.includes(ROLES.SUPER_ADMIN) && <>مشتری
              <ReferenceField link="show" source="company" reference="customer" >
                <ChipField source="name" />
              </ReferenceField>
              <br />
              <br />
            </>}
            زمان تماس <br /><DateField source="callTime" options={{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
            <br />
            <br />
            یادداشت <ChipField source="description" style={{ fontSize: "8pt" }} />

          </Grid>
        </Grid>


        <br />


      </div>
    </Show >
  )
};
export const ReminderCreate = (props) => {
  const [contactData, setContactData] = useState({ contact: undefined })
  const [disableInput, setDisableInput] = useState(false)


  const handlePhoneChange = (event) => {
    console.log("injaa change", event.target.value)
    HttpClient(SERVER + `/admin/contact/phone/` + event.target.value, {
      method: "GET",
    })
      .then(({ headers, json }) => {
        if (json.result) {
          setContactData(json.result)
          setDisableInput(true)
          // setValue("contactName", json.result.name);
          // form.change("contactName", json.result.name);

        } else {
          setDisableInput(false)

        }

      })
      .catch((e) => {
      });

  }

  const { permissions } = usePermissions();

  return (
    <Create {...props} class="flex-column">
      <SimpleForm submitOnEnter={false} variant="outlined" redirect="list" >
        <Grid container spacing={3} style={{ marginRight: "16px" }}>
          <Grid item xs={4} style={{ display: 'inline-grid' }}>
            <TextInput source="title" label="عنوان" variant="outlined" />
            <ReferenceArrayInput variant="outlined" defaultValue={contactData?.users} source="users" label="همکاران" reference="adminUsers">
              {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
              <AutocompleteArrayInput source="name" optionText="name" />
            </ReferenceArrayInput >

            <TextInput source="phoneNumber" variant="outlined" label="شماره تماس" onChange={handlePhoneChange} />
            <TextInput type="text" variant="outlined" defaultValue={contactData.name} disabled={disableInput} source="contactName" label="نام مخاطب" />
            <ReferenceInput source="callType" label="نوع تماس" variant="outlined" reference="preferCall">
              <SelectInput optionText="title" />
            </ReferenceInput>


            {permissions?.includes(ROLES.SUPER_ADMIN) && <ReferenceInput defaultValue={contactData?.company} variant="outlined" label="مشتری من" source="company" reference="customer">
              <AutocompleteInput optionText="name" />
            </ReferenceInput>}

            <TextInput source="companyName" label="نام مشتری"  variant="outlined" />

            <TextInput source="description" label="یادداشت" multiline variant="outlined" rows={5} width="60%" />

            {isMobile ? (
              <div>
                <IdateTimeInput fullWidth source='reminderTime' variant="outlined" label="زمان پیگیری" />
                <br />
                <BooleanInput source="repetitive" label="تکرار شود" variant="outlined" />
                <br />
                <FormDataConsumer>
                  {({ formData, ...rest }) => formData.repetitive && <div>

                    <RadioButtonGroupInput label="" row={false} defaultValue="EVERY_1_WEEK" source="reminderPeriod" choices={choicesTime} />
                  </div>
                  }
                </FormDataConsumer>
              </div>

            ) : (
              <></>
            )}
          </Grid>
          {!isMobile ? (

            <Grid item xs={6}>
              <IdateTimeInput fullWidth source='reminderTime' variant="outlined" label="زمان پیگیری" />


              <br />
              <BooleanInput source="repetitive" label="تکرار شود" variant="outlined" />
              <br />
              <FormDataConsumer>
                {({ formData, ...rest }) => formData.repetitive && <div>

                  <RadioButtonGroupInput label="" row={false} defaultValue="EVERY_1_WEEK" source="reminderPeriod" choices={choicesTime} />
                </div>
                }
              </FormDataConsumer>
            </Grid>
          ) : (<></>)}

        </Grid>

      </SimpleForm>
    </Create >
  )
};




